import React from 'react';

type SectionProps = {
  children: React.ReactElement;
  title: string;
}

export const Section = ({ children, title }: SectionProps) => {
  return (
    <div className="d-block my-3 border border-secondary rounded p-3 bg-light">
      <div className="font-weight-bold">{title}</div>
      {children}
    </div>
  );
};
